module.exports = __webpack_public_path__ + "img/wave-4.76257183.svg";